import { Rect } from "./Rect";
// export * from "./Rect";

export var geometries = {
    Rect,
};